import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { Btn2 } from "../../common/btn";

const Hero2 = ({ data }) => {
  const color = data.textColor.hex;

  // Add overlay styling based on bgOverlay data
  const overlayStyle = data.bgOverlay?.rgb
    ? {
        backgroundColor: `rgba(${data.bgOverlay.rgb.r}, ${data.bgOverlay.rgb.g}, ${data.bgOverlay.rgb.b}, ${data.bgOverlay.rgb.a})`,
      }
    : null;

  // Map textAlignment values to Tailwind classes
  const getTextAlignmentClass = (alignment) => {
    const alignmentMap = {
      left: "items-start text-left",
      center: "items-center text-center",
      right: "items-end text-right",
    };
    return alignmentMap[alignment] || "items-start text-left"; // Default to left
  };

  const textAlignmentClasses = getTextAlignmentClass(data.textAlignment);

  return (
    <div className="w-full flex flex-col lg:flex-row items-center min-h-[450px] h-full relative">
      {/* Left */}
      <div className="absolute top-0 right-0 bottom-0 left-0 w-full h-full z-0">
        <video
          src={data.video.asset.url}
          autoPlay
          muted
          loop
          playsInline
          webkit-playsinline="true"
          preload="auto"
          className="object-cover w-full h-full"
          controls={false}
          style={{
            pointerEvents: "none",
          }}
        ></video>
      </div>
      {/* Add overlay div */}
      <div
        className="w-full h-full absolute inset-0 z-[1]"
        style={
          overlayStyle || {
            background:
              "linear-gradient(to bottom left, rgba(0,0,0,0.3), rgba(255,255,255,0.15))",
          }
        }
      ></div>
      <div
        className={`w-full relative z-10 flex-1 h-full flex flex-col ${textAlignmentClasses}
           justify-between md:justify-center md:px-10 lg:px-[104px] py-[80px]`}
      >
        <div className={`w-full flex flex-col ${textAlignmentClasses}`}>
          <h1
            className={`block font-bold text-[70px] leading-[75px] tracking-tight ${
              data.textAlignment !== "center" ? "max-w-[603px]" : "mx-auto"
            }`}
            style={{ color: `${color}` }}
          >
            {data.title}
          </h1>
          {data.subTitle && (
            <p
              className={`block text-[28px] leading-9 mt-5 mb-5 ${
                data.textAlignment !== "center" ? "max-w-[494px]" : "mx-auto"
              }`}
              role="heading"
              style={{ color: `${color}` }}
            >
              {data.subTitle}
            </p>
          )}
        </div>
        {data.button?.buttonText && (
          <div className="relative overflow-visible group">
            <Btn2 data={data.button} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Hero2;
